var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "club-points-history-table" },
    _vm._l(_vm.historyRecords, function(record, index) {
      return _c("mobile-row", {
        key: index,
        attrs: {
          points: record.bonusesUsed,
          date: _vm.formatDate(record.date),
          "is-add-mode": record.bonusesUsed > 0,
          sum: record.bonusesTotal,
          description: record.description,
          "burns-at": _vm.formatDate(record.dateEnd),
          "order-number": record.orderNumber,
          receipt: record.receipt
        }
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }